var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "container container-medium" }, [
    _c("div", { staticClass: "steps-wrapper" }, [
      _c("div", { staticClass: "strike-through" }),
      _c(
        "div",
        { staticClass: "steps" },
        _vm._l(_vm.steps, function (step) {
          return _c("div", { key: step.id, staticClass: "step" }, [
            _c(
              "div",
              {
                staticClass: "step-bullet",
                class: {
                  active: step.stepNumber <= _vm.currentPage,
                  "not-active": step.stepNumber > _vm.currentPage,
                },
              },
              [
                step.route
                  ? [
                      _c(
                        "router-link",
                        { attrs: { to: { name: step.route } } },
                        [
                          _vm.currentPage > step.stepNumber
                            ? _c("div", { staticClass: "icon v-icon" })
                            : _c("div", [_vm._v(_vm._s(step.stepNumber))]),
                        ]
                      ),
                    ]
                  : [
                      _vm.currentPage > step.stepNumber
                        ? _c("div", { staticClass: "icon v-icon" })
                        : _c("div", [_vm._v(_vm._s(step.stepNumber))]),
                    ],
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "step-name" },
              [
                step.route
                  ? [
                      _c(
                        "router-link",
                        { attrs: { to: { name: step.route } } },
                        [_vm._v(" " + _vm._s(step.name) + " ")]
                      ),
                    ]
                  : [_vm._v(" " + _vm._s(step.name) + " ")],
              ],
              2
            ),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }